<template>
  <div id="wrapper">
    <div class="tracking">
      {{ current + 1 }} / {{ total }}
    </div>
    <div id="container">
      <v-icon
        v-if="problems.length > 1"
        class="as-btn"
        :disabled="current == 0"
        @click="current--"
      >
        mdi-chevron-left
      </v-icon>
      <div class="problem">
        <div class="flex-container">
          <div class="problem-description">
            <div class="nl2br">
              {{ problem.description }}
            </div>
            <div
              v-if="problem.is_accident"
              class="has-accident"
            >
              <div
                class="icon-container"
                :class="{accident: problem.is_accident}"
                :title="problem.is_accident ? 'An accident occurred' : 'No accident occurred'"
              >
                <v-icon>mdi-account-injury-outline</v-icon>
              </div>
              <a @click="downloadReport(problem)">Download report</a>
            </div>
            <div
              v-if="problem.documents.length"
              layout="column"
              layout-align="start center"
              layout-wrap
              class="mt-2"
            >
              <div
                v-for="m in problem.documents"
                :key="'pic_'+ m.id"
                class="mb-2 clickable"
                style="position: relative"
              >
                <img
                  :src="getImageData(m.id)"
                  style="max-width: 100%; max-height: 100px"
                  @click="$refs['pic-dialog'].show(getImageData(m.id))"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-icon
        v-if="problems.length > 1"
        class="as-btn"
        :disabled="current == total-1"
        @click="current++"
      >
        mdi-chevron-right
      </v-icon>
    </div>
    <picture-dialog ref="pic-dialog" />
  </div>
</template>
<script>
  import axios from 'axios'
  import ImageMixin from '@/mixins/image'
  import PictureDialog from "@/components/shared/PictureDialog.vue"
  export default {
    components: {PictureDialog},
    mixins: [ImageMixin],
    props: ['problems'],
    data() {
      return {
        current: 0,
        imgs: {},
        imgsLoad: {},
      }
    },
    computed: {
      total() {
        return this.problems.length
      },
      problem() {
        return this.problems[this.current]
      }
    },
    mounted () {
      this.problems.forEach(p => {
        if(p.documents && p.documents.length){
          p.documents.forEach(d => {
            this.getImage(
              "/assets/problemDocuments/" + d.id,
              d.id
            )
          })
        }
      })
    },
    methods: {
      downloadReport (problem) {
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);

        axios.get(`/sessions/${this.$route.params.id}/daggesrapports-problems/${problem.id}/report`, {responseType: 'blob'}).then(res => {
          let blob = new Blob([res.data], {type: "octet/stream"});

          if (window.navigator && window.navigator.msSaveOrOpenBlob){
            window.navigator.msSaveBlob(blob, problem.report.name); //il faudra aller chercher le vrai nom du fichier
          }
          else
          {
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = problem.report.name
            a.click();
            window.URL.revokeObjectURL(url);
          }
        })
      }
    }
  }

</script>
<style scoped lang="sass">
  #wrapper
    flex-grow: 1

    .tracking
      width: 100%
      text-align: center
      font-size: 0.85em
      color: #C1C1C1

  #container
    display: flex
    flex-direction: row
    align-items: flex-start
    justify-content: space-between
    background-color: #FAFAFA
    padding: 10px
    border-radius: 2px

  .as-btn
    display: flex
    align-items: center
    justify-content: center
    background: #F1F1F1
    width: 30px
    height: 30px
    border-radius: 50%
    flex-shrink: 0
    color: #f4b944

    &:hover
      background-color: #fef9eb

  .problem
    flex-grow: 1
    margin-left: 8px
    margin-right: 8px

    .flex-container
      display: flex
      flex-direction: row

      .problem-description
        .nl2br
          margin-bottom: 5px

      .has-accident
        display: flex
        align-items: center

        > .icon-container
          border-radius: 50%
          background-color: tomato
          width: 20px
          height: 20px
          display: flex
          justify-content: center
          align-items: center
          margin-right: 8px

          i
            color: white
            font-size: 1em
</style>
